// Client-side analytics components
export { VisitorTracker, type VisitorTrackerProps } from '../visitor-tracker'; 